import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import { getTenantPrefix } from './ProxyPathService';
import { getLocales } from './TranslationsService';
import { getCurrentLngFromLocalStorage } from 'utils/localStorage';

const fetchCurrentLng = async () => {
  // Check local storage language.
  let currentLng = getCurrentLngFromLocalStorage();

  // If there was not set language to currentLng, then use window.navigator.language.
  if (!currentLng) {
    // Browser window.navigator.language is formated as simplified locale code - 'de'.
    currentLng = window.navigator.language;

    // Get locales settings
    const localeFromDb = await getLocales()
      .then(({ data }) => {
        const locales = data.items;
        return locales.find((x) => x.key.toLowerCase().includes(currentLng.toLocaleLowerCase()))?.key;
      })
      .catch((error) => {
        console.error(error);
        return currentLng;
      });

    // Assign the found locale from DB in the right format (de-DE) or if not found set default 'en-GB'.
    currentLng = localeFromDb ?? 'en-GB';
    console.log('currentLng', currentLng);
    localStorage.setItem('currentLng', currentLng);
  }

  return currentLng;
};

export const reloadTranslations = async () => {
  const tenantPrefix = getTenantPrefix();
  const currentLng = getCurrentLngFromLocalStorage() || i18n.language;

  i18n.options.backend = {
    ...i18n.options.backend,
    loadPath: `/api/${tenantPrefix}v1/Translations?Locale={{lng}}`,
    addPath: `/api/${tenantPrefix}v1/Translations?Locale={{lng}}`,
  };

  await i18n.reloadResources(currentLng);
};

export const initI18n = async () => {
  const tenantPrefix = getTenantPrefix();
  // Set default locale before settings check
  const currentLng = await fetchCurrentLng();

  i18n
    .use(initReactI18next)
    .use(Backend)
    // passes i18n down to react-i18next
    .init({
      interpolation: {
        escapeValue: false,
      },
      lng: currentLng,
      fallbackLng: currentLng,
      load: 'currentOnly',
      react: {
        wait: true,
      },
      backend: {
        loadPath: `/api/${tenantPrefix}v1/Translations?Locale={{lng}}`,
        addPath: `/api/${tenantPrefix}v1/Translations?Locale={{lng}}`,
        allowMultiLoading: false,
      },
    });
};

export default i18n;
